import React from "react";
import Link from "../../Link";
import { Flex, Text } from "@familyzone/component-library";

export default class SubNavItem extends React.Component {
  constructor(props) {
    super(props);
    this.unsubAccountStore = null;
  }

  render() {
    const { name, to } = this.props;
    const isActive = process.env.NODE_ENV === "development" ? window.location.hash === `#${to}` : window.location.pathname === to;
    const color = isActive ? "neutrals.0" : "neutrals.900";

    return (
      <Link to={to}>
        <Flex mr="sp8">
          <Flex
            flexGrow={1}
            alignItems="center"
            p="sp8"
            ml="sp2"
            bg={isActive ? "#4D5A6B" : "transparent"}
            borderRadius="xs"
            flexShrink="1"
            mr="auto"
            _hover={isActive ? {} : { bg: "#F1F5F9" }}
          >
            <Text fontSize="md" color={color} mr="auto">
              {name}
            </Text>
          </Flex>
        </Flex>
      </Link>
    );
  }
}
